import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../Redux/Slices/Utility/LoginSlice";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import logoImg from "../../Asset/Image/Login/Logo.png";
import { Alert } from "react-bootstrap";
import { IoMdEyeOff } from "react-icons/io";
import { IoEye } from "react-icons/io5";
import { HttpMethod } from "../../Asset/httpMethod";

function Login() {

  const dispatch = useDispatch();
  const navigate = useNavigate(); // Correctly named as navigate for clarity
  const [rememberMe, setRememberMe] = useState(false);
  const [showAlert, setShowAlert] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => setShowPassword(prev => !prev);

  let UserLogin = useSelector((state) => state.UserLogin);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    if (rememberMe) {
      localStorage.setItem("rememberLogin", btoa(JSON.stringify({ userName: data.Username, Password: btoa(data.Password) })));
    } else {
      localStorage.removeItem("rememberLogin");
    }
    await dispatch(loginUser(data, navigate));
  };
  const DropDown = useSelector(state => state.DropDown);
  let Setting = useSelector(state => state.Setting.Setting);
  let CompCode = Setting?.find(Setting => Setting.SKEY === 'COMP_CODE')?.SVALUE;

  useEffect(() => {
    // if (UserLogin.user && UserLogin.isAuthenticated === true) { 
    //   dispatch(fetchMenuPermition())
    //   navigate("/");
    // }
    // if (UserLogin.user && UserLogin.isAuthenticated === true) {
    //   dispatch(fetchMenuPermition())
    //   navigate("/");
    // }


    const fetchProfile = async () => {
      try {

        if (UserLogin.user) {

          const { data } = await HttpMethod.get('/Authorization/Account/Profile');

          const isStoneSearchUser =
            CompCode === "Valam" ||
            CompCode === "SILVER" ||
            (CompCode === "Vanora" && data?.RoleGroup === "Web User") ||
            (CompCode === "SUN" && data?.RoleGroup === "Web User");

          debugger
          navigate(isStoneSearchUser ? '/StoneSearch' : '/');

        }

      } catch (error) {
        console.error("Profile Fetch Error:", error);
      }
    };

    fetchProfile();

  }, [UserLogin]);

  // const handleForgotPassword = async (email) => {
  //   dispatch(forgotPassword(email));
  // };

  useEffect(() => {
    let storedUserdata = localStorage?.getItem("rememberLogin");
    if (storedUserdata) {
      storedUserdata = JSON.parse(atob(storedUserdata))
      setValue("Username", storedUserdata.userName);
      setValue("Password", atob(storedUserdata.Password));
      setRememberMe(true); // Assuming you want to check the checkbox if the username is remembered
    }
  }, [UserLogin]);

  return (

    <div className="login_page">
      <div className="login_overlay" />
      <div className="login_wrapper">
        <div className="login_side">
          <div className="login_side_inner">
            <img src={logoImg} alt="Logo" className="login_side_logo" />
            <p className="login_side_title">NATURAL FOREVER</p>
          </div>
        </div>
        <div className="login_card">
          <div className="login_card_header">
            <h2>Sign In here</h2>
            <span className="login_card_subtitle">Username or Email</span>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="login_form">
            <div className="mb-3">
              <input
                type="text"
                placeholder="Enter Username or Email"
                className="form-control login_input"
                name="Username"
                autoComplete="username"
                {...register("Username", {
                  required: "This field is required",
                })}
              />
              {errors.Username && (
                <span className="validation">{errors.Username.message}</span>
              )}
            </div>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                className="form-control login_input pe-5"
                name="Password"
                autoComplete="current-password"
                {...register("Password", {
                  required: "This field is required",
                })}
              />
              <span
                className="password_toggle"
                onClick={togglePasswordVisibility}
              >
                {showPassword ? <IoMdEyeOff /> : <IoEye />}
              </span>
              {errors.Password && (
                <span className="validation">{errors.Password.message}</span>
              )}
            </div>
            <div className="login_options d-flex align-items-center justify-content-between mb-4">
              <label className="remember_label">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>Remember me</span>
              </label>
              <Link to="/forgotpassword" className="forgot_link">
                Forgot Password?
              </Link>
            </div>
            <button className="login_button btn btn-primary w-100 mb-3" type="submit">
              Login
            </button>
            <div className="register_line text-center">
              <span>New Registration?</span>
              <Link to="/Register" className="register_link">
                SignUp
              </Link>
            </div>
          </form>
          <Alert
            variant="success"
            show={showAlert}
            onClose={() => setShowAlert(false)}
            dismissible
          >
            Password reset email sent!
          </Alert>
        </div>
      </div>
    </div>
  );
}
export default Login;
